import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import api from 'services/api';
import { setApiToken } from 'store/Auth/slice';
import { fetchPosts } from 'store/DirectPosts/slice';
import {
  fetchCoinInfo,
  fetchCoinInfoSuccess,
  fetchInfo,
  fetchInfoSuccess,
  selectCoin,
} from 'store/TokenTeam/slice';
import { getSelectedCoinInfo } from './selectors';
import * as Sentry from '@sentry/nextjs';

function* fetchTokenTeamInfoFlow() {
  try {
    let data: any = {};
    try {
      const { data: response } = yield call(api.get, `/auth/info`);
      data = response.data;
    } catch (err) {
      yield put(setApiToken(null));
      return;
    }

    yield put(fetchInfoSuccess(data));
    yield put(fetchPosts());
  } catch (error) {
    Sentry.captureException(error);
  }
}

function* fetchTokenTeamInfoFlowWatcher() {
  yield takeEvery(fetchInfo.toString(), fetchTokenTeamInfoFlow);
}

function* fetchCoinInfoFlow() {
  try {
    const coin = yield select(getSelectedCoinInfo);
    const { data: response } = yield call(api.get, `/coin/info/${coin.id}`);
    yield put(fetchCoinInfoSuccess(response.data));
  } catch (error) {
    Sentry.captureException(error);
  }
}

function* fetchCoinInfoFlowWatcher() {
  yield takeEvery(
    [
      selectCoin.toString(),
      fetchInfoSuccess.toString(),
      fetchCoinInfo.toString(),
    ],
    fetchCoinInfoFlow,
  );
}

export default [
  fork(fetchTokenTeamInfoFlowWatcher),
  fork(fetchCoinInfoFlowWatcher),
];
